// BlockTypeSelector > IBlockTypeSelector
import { IBlockType } from '../BlockType'
import { ComponentType } from 'react'

export const blockTypeSelectorDefaultProps = Object.freeze({
	disabled: false,
	withManagement: false
})

export type BlockTypeSelectorProps<BlockTypesType> = {
	multiSelect: boolean
	selected: string[]
	blockTypes: IBlockType<BlockTypesType>[]
	onSelect(ix: string): void
	AddBlockTypeComponent?: ComponentType
	removeBlockType?(resource: BlockTypesType): void
} & typeof blockTypeSelectorDefaultProps
